export const scatter = {
    point: {
        style: {
            size: 8,
            symbolType: "circle",
            lineWidth: 0,
            fillOpacity: .8
        }
    },
    label: {
        visible: !1,
        offset: 5,
        position: "top",
        style: {
            lineWidth: 2,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    }
};
//# sourceMappingURL=scatter.js.map
